class TpCardsFilter extends HTMLElement {
  connectedCallback() {
    this.filterButtons = Array.from(this.querySelectorAll('.tp-e-cards-filter-v1__filter'));
    this.cards = Array.from(this.querySelectorAll('.tp-e-cards-filter-v1__card'));
    this.emptyMessage = this.querySelector('.tp-e-cards-filter-v1__empty');

    if (!this.filterButtons.length) return;

    this.onClick = this.onClick.bind(this);
    this.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
  }

  onClick(event) {
    const button = event.target.closest('.tp-e-cards-filter-v1__filter');
    if (!button || !this.contains(button)) return;

    this.filterButtons.forEach((btn) => btn.classList.toggle('is-active', btn === button));
    this.applyFilter(button.dataset.filter);
  }

  applyFilter(filter) {
    let visibleCount = 0;

    this.cards.forEach((card) => {
      const tags = (card.dataset.tags || '').split(/\s+/).filter(Boolean);
      const matches = filter === '*' || tags.includes(filter);
      card.hidden = !matches;
      if (matches) visibleCount += 1;
    });

    if (this.emptyMessage) {
      this.emptyMessage.hidden = visibleCount > 0;
    }
  }
}

if (!customElements.get('tp-cards-filter')) {
  customElements.define('tp-cards-filter', TpCardsFilter);
}
